//updated_wc_div

const novada_updated_wc_div = (e) => {
  document.body.dispatchEvent(new CustomEvent('novada_updated_wc_div', {bubbles: true}));
}

document.body.addEventListener('updated_wc_div', novada_updated_wc_div);
jQuery(document.body).on('updated_wc_div', novada_updated_wc_div);
